import { IURIPartial } from '@cian/http-api/shared/URI/IURI';

export const ADDRESS_SUGGEST_URI: IURIPartial = {
  scheme: 'https',
  host: 'suggestions.dadata.ru',
  path: '/suggestions/api/4_1/rs/suggest/address',
};
